module.exports = fox._r("fonts/PTSans-Regular.woff", __webpack_public_path__ + "_/_/_/root/fonts/2lRgd_2.woff");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Regular.woff
// module id = 194
// module chunks = 4